/**
 * Balatro-Style Pixel Art Radio Tower Component
 * True pixel-art with dithered shading, not CSS gradients
 */
export const RadioTower = ({ size = 80, animated = true, className = '' }) => {
  return (
    <div 
      className={`inline-block ${className}`}
      style={{ 
        width: size, 
        height: size,
        filter: 'drop-shadow(5px 5px 0px rgba(0,0,0,0.4)) drop-shadow(8px 8px 12px rgba(0,0,0,0.2))'
      }}
      data-testid="radio-tower"
    >
      <svg 
        viewBox="0 0 32 32" 
        width={size} 
        height={size}
        style={{ imageRendering: 'pixelated' }}
      >
        {/* Pixel-art radio tower with discrete shading */}
        
        {/* Ground/base - grass green with dithering */}
        <rect x="6" y="28" width="20" height="3" fill="#4B8B3B" />
        <rect x="7" y="28" width="1" height="1" fill="#5fa04a" />
        <rect x="9" y="28" width="1" height="1" fill="#5fa04a" />
        <rect x="11" y="28" width="1" height="1" fill="#5fa04a" />
        <rect x="13" y="28" width="1" height="1" fill="#5fa04a" />
        <rect x="15" y="28" width="1" height="1" fill="#5fa04a" />
        <rect x="17" y="28" width="1" height="1" fill="#5fa04a" />
        <rect x="19" y="28" width="1" height="1" fill="#5fa04a" />
        <rect x="21" y="28" width="1" height="1" fill="#5fa04a" />
        <rect x="23" y="28" width="1" height="1" fill="#5fa04a" />
        <rect x="6" y="30" width="20" height="1" fill="#3a6e2e" />
        
        {/* Left tower leg - metal with pixel shading */}
        <rect x="10" y="10" width="3" height="18" fill="#888888" />
        <rect x="10" y="10" width="1" height="18" fill="#aaaaaa" />
        <rect x="12" y="10" width="1" height="18" fill="#666666" />
        
        {/* Right tower leg */}
        <rect x="19" y="10" width="3" height="18" fill="#888888" />
        <rect x="19" y="10" width="1" height="18" fill="#aaaaaa" />
        <rect x="21" y="10" width="1" height="18" fill="#666666" />
        
        {/* Cross beams - horizontal */}
        <rect x="11" y="24" width="10" height="2" fill="#1a1a1a" />
        <rect x="12" y="19" width="8" height="2" fill="#1a1a1a" />
        <rect x="13" y="14" width="6" height="2" fill="#1a1a1a" />
        
        {/* Diagonal bracing pixels */}
        <rect x="13" y="22" width="1" height="1" fill="#555555" />
        <rect x="14" y="21" width="1" height="1" fill="#555555" />
        <rect x="17" y="21" width="1" height="1" fill="#555555" />
        <rect x="18" y="22" width="1" height="1" fill="#555555" />
        <rect x="14" y="17" width="1" height="1" fill="#555555" />
        <rect x="15" y="16" width="1" height="1" fill="#555555" />
        <rect x="16" y="16" width="1" height="1" fill="#555555" />
        <rect x="17" y="17" width="1" height="1" fill="#555555" />
        
        {/* Antenna mast */}
        <rect x="15" y="3" width="2" height="8" fill="#888888" />
        <rect x="15" y="3" width="1" height="8" fill="#aaaaaa" />
        
        {/* Beacon light - red with glow */}
        <rect x="14" y="1" width="4" height="3" fill="#cc0000" />
        <rect x="15" y="1" width="2" height="1" fill="#ff3333" />
        <rect x="15" y="2" width="1" height="1" fill="#ff6666" />
        
        {/* Beacon glow effect - animated */}
        {animated && (
          <>
            <rect x="13" y="0" width="1" height="1" fill="#cc0000" opacity="0.5">
              <animate attributeName="opacity" values="0.5;0;0.5" dur="1s" repeatCount="indefinite" />
            </rect>
            <rect x="18" y="0" width="1" height="1" fill="#cc0000" opacity="0.5">
              <animate attributeName="opacity" values="0.5;0;0.5" dur="1s" repeatCount="indefinite" />
            </rect>
            <rect x="12" y="2" width="1" height="1" fill="#cc0000" opacity="0.3">
              <animate attributeName="opacity" values="0.3;0;0.3" dur="1s" repeatCount="indefinite" begin="0.2s" />
            </rect>
            <rect x="19" y="2" width="1" height="1" fill="#cc0000" opacity="0.3">
              <animate attributeName="opacity" values="0.3;0;0.3" dur="1s" repeatCount="indefinite" begin="0.2s" />
            </rect>
          </>
        )}
        
        {/* Left signal waves - pixel art style */}
        <rect x="9" y="4" width="2" height="1" fill="#cc0000" opacity={animated ? undefined : "0.8"}>
          {animated && <animate attributeName="opacity" values="0.8;0.2;0.8" dur="1.5s" repeatCount="indefinite" />}
        </rect>
        <rect x="8" y="5" width="1" height="2" fill="#cc0000" opacity={animated ? undefined : "0.8"}>
          {animated && <animate attributeName="opacity" values="0.8;0.2;0.8" dur="1.5s" repeatCount="indefinite" />}
        </rect>
        <rect x="6" y="3" width="2" height="1" fill="#cc0000" opacity={animated ? undefined : "0.6"}>
          {animated && <animate attributeName="opacity" values="0.6;0.1;0.6" dur="1.5s" repeatCount="indefinite" begin="0.3s" />}
        </rect>
        <rect x="5" y="4" width="1" height="3" fill="#cc0000" opacity={animated ? undefined : "0.6"}>
          {animated && <animate attributeName="opacity" values="0.6;0.1;0.6" dur="1.5s" repeatCount="indefinite" begin="0.3s" />}
        </rect>
        <rect x="3" y="2" width="2" height="1" fill="#cc0000" opacity={animated ? undefined : "0.4"}>
          {animated && <animate attributeName="opacity" values="0.4;0;0.4" dur="1.5s" repeatCount="indefinite" begin="0.6s" />}
        </rect>
        <rect x="2" y="3" width="1" height="4" fill="#cc0000" opacity={animated ? undefined : "0.4"}>
          {animated && <animate attributeName="opacity" values="0.4;0;0.4" dur="1.5s" repeatCount="indefinite" begin="0.6s" />}
        </rect>
        
        {/* Right signal waves - pixel art style */}
        <rect x="21" y="4" width="2" height="1" fill="#cc0000" opacity={animated ? undefined : "0.8"}>
          {animated && <animate attributeName="opacity" values="0.8;0.2;0.8" dur="1.5s" repeatCount="indefinite" />}
        </rect>
        <rect x="23" y="5" width="1" height="2" fill="#cc0000" opacity={animated ? undefined : "0.8"}>
          {animated && <animate attributeName="opacity" values="0.8;0.2;0.8" dur="1.5s" repeatCount="indefinite" />}
        </rect>
        <rect x="24" y="3" width="2" height="1" fill="#cc0000" opacity={animated ? undefined : "0.6"}>
          {animated && <animate attributeName="opacity" values="0.6;0.1;0.6" dur="1.5s" repeatCount="indefinite" begin="0.3s" />}
        </rect>
        <rect x="26" y="4" width="1" height="3" fill="#cc0000" opacity={animated ? undefined : "0.6"}>
          {animated && <animate attributeName="opacity" values="0.6;0.1;0.6" dur="1.5s" repeatCount="indefinite" begin="0.3s" />}
        </rect>
        <rect x="27" y="2" width="2" height="1" fill="#cc0000" opacity={animated ? undefined : "0.4"}>
          {animated && <animate attributeName="opacity" values="0.4;0;0.4" dur="1.5s" repeatCount="indefinite" begin="0.6s" />}
        </rect>
        <rect x="29" y="3" width="1" height="4" fill="#cc0000" opacity={animated ? undefined : "0.4"}>
          {animated && <animate attributeName="opacity" values="0.4;0;0.4" dur="1.5s" repeatCount="indefinite" begin="0.6s" />}
        </rect>
        
        {/* Tower outline - crisp pixel border */}
        <rect x="9" y="10" width="1" height="18" fill="#1a1a1a" />
        <rect x="13" y="10" width="1" height="18" fill="#1a1a1a" />
        <rect x="18" y="10" width="1" height="18" fill="#1a1a1a" />
        <rect x="22" y="10" width="1" height="18" fill="#1a1a1a" />
        <rect x="10" y="9" width="3" height="1" fill="#1a1a1a" />
        <rect x="19" y="9" width="3" height="1" fill="#1a1a1a" />
        
        {/* Base outline */}
        <rect x="5" y="28" width="1" height="3" fill="#1a1a1a" />
        <rect x="26" y="28" width="1" height="3" fill="#1a1a1a" />
        <rect x="6" y="31" width="20" height="1" fill="#1a1a1a" />
      </svg>
    </div>
  );
};

export default RadioTower;
